import React, {useEffect} from "react";
import "../../assets/styles/components/newInput.scss";
import IconEdit from "../../assets/svg/pen-icon-account.svg";
import IconDelete from "../../assets/svg/icon-delete-show-account.svg";

export default function NewInput(props) {
    const {
        label,
        value,
        onChange,
        placeholder,
        type,
        disabled,
        ref,
        deleteIcon,
        editIcon,
        editInput,
        showValue,
    } = props;
    useEffect(() => {
    });
    return (
        <>
            {label == null ? <></> : <label className="label-wrap-new-input">{label}</label>}
            <div className={disabled ? "disabled-wrap-new-input" : "wrap-new-input"}>
                <input
                    ref={ref}
                    onChange={onChange}
                    value={value ?? null}
                    className="c-new-input"
                    placeholder={placeholder}
                    type={type}
                    disabled={disabled}
                />
                {editIcon ? (
                    <img
                        className="icon-edit-new-input"
                        src={IconEdit}
                        alt="IconEdit"
                        onClick={() => editInput(!showValue)}
                    />
                ) : null}
                {deleteIcon ? <img className="icon-delete-new-input" src={IconDelete} alt="IconDelete"/> : null}
            </div>
        </>
    );
}
